import {
    ChangeDetectionStrategy,
    Component,
    Input,
    OnDestroy,
    OnInit,
    inject,
} from '@angular/core';
import { UserService } from 'app/core/user/user.service';
import { User } from 'app/core/user/user.types';
import { takeUntil } from 'rxjs';
import { BaseUserComponent } from './base-user.component';

@Component({
    selector: 'user',
    templateUrl: './user.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [...BaseUserComponent.imports], // Import inherited modules
})
export class UserComponent
    extends BaseUserComponent
    implements OnInit, OnDestroy
{
    private _userService = inject(UserService);

    @Input() showAvatar: boolean = true; // does not work from base component

    user: User;

    ngOnInit(): void {
        this.subscribeToUserChanges();
    }

    ngOnDestroy(): void {
        this.destroy();
    }

    subscribeToUserChanges(): void {
        this._userService.user$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((user) => {
                this.user = user;

                // Mark for check
                this._changeDetectorRef.markForCheck();
            });
    }

    updateUserStatus(status: string): void {
        if (!this.user) {
            return;
        }

        this._userService
            .update({
                ...this.user,
                status,
            })
            .subscribe(() => {
                console.log('User status updated.');
            });
    }
}
